import { render, staticRenderFns } from "./CouponStatusCard.vue?vue&type=template&id=155e2b96&scoped=true&"
import script from "./CouponStatusCard.vue?vue&type=script&lang=js&"
export * from "./CouponStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponStatusCard.vue?vue&type=style&index=0&id=155e2b96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155e2b96",
  null
  
)

export default component.exports